import React from "react"
import * as styles from "./footerstyles.module.scss"
import { MobileFooter } from "./MobileFooter"
import { Link } from "gatsby"
import { SocialLinks } from "./SocialLinks"
import translate from "../../helpers/Translate"
import settings from "../../helpers/settings"

export const Footer = () => {

	const menu = settings[ process.env.GATSBY_SITE_LANG ].firstfooterMenu 

	const menu2 = settings[ process.env.GATSBY_SITE_LANG ].secondFooterMenu 

	const menu3 = settings[ process.env.GATSBY_SITE_LANG ].thirdFooterMenu 

	const logo = settings[ process.env.GATSBY_SITE_LANG ].logo 

	const lang = process.env.GATSBY_SITE_LANG

    return(
		<>
			<footer className={styles.siteFooter}>
				<div className={`wrapper ${styles.footerWrapper} `}>
					<div className={styles.footerCol}>
							<img 
								src={logo} 
								className={styles.footerLogo} 
								alt={'en' === lang ? 'Bedbible logo - Sexual Wellness Insights & Sex Toy Reviews' : 'Lovefreund logo - Einblicke in sexuelle Wellness und Sexspielzeug-Bewertungen'}/>
							<p>
								{translate('Your Trusted Source for Sexual Wellness Insights and Honest Product Reviews. Discover user-reviewed sex toys and lubricants, and explore our extensive resources on sexual wellness. From in-depth studies to practical guides, we empower and inform with accuracy and reliability.')}
							</p>
							<div className={styles.followUs}>
							<span><strong>{translate('Follow us:')}</strong></span>
							<div className={styles.socialLinks}>
								<SocialLinks/>
							</div>
						</div>
					</div>

					<div className={styles.footerCol}>
						<div className={`${styles.footerCol} ${styles.footer__menu__links}`}>		
							<div className={styles.footerCol__links}>
								<span className={styles.column__name}>{translate('Information')}</span>
								<ul className={styles.footerMenu}>
									{menu.map((item, id) =>
										<li key={`m1-${id}`}>
											<Link to={item.url} className={styles.footerMenu__link}>
												{item.label}
											</Link>
										</li>
									)}
								</ul>
							</div>

							{menu3.length > 0 &&
							<div className={styles.footerCol__links}>
								<span className={styles.column__name}>{translate('Resources')}</span>
								<ul className={styles.footerMenu}>
									{menu3.map((item, id) =>
										<li key={`m2-${id}`}>
											<Link to={item.url} className={styles.footerMenu__link}>
												{item.label}
											</Link>
										</li>
									)}
								</ul>
							</div>}

							<div className={styles.footerCol__links}>
								<span className={styles.column__name}>{translate('Reviews')}</span>
								<ul className={styles.footerMenu}>
									{menu2.map((item, id) =>
										<li key={`m2-${id}`}>
											<Link to={item.url} className={styles.footerMenu__link}>
												{item.label}
											</Link>
										</li>
									)}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className='wrapper'>
					<div className={styles.bottomLine}>
						<p className={styles.footerCopyright}>
							{settings[ process.env.GATSBY_SITE_LANG ].copyrights}
						</p>
					</div>
				</div>
			</footer>
			<MobileFooter menu={menu} menu2={menu2} menu3={menu3} logo={logo} alt={'en' === lang ? 'Bedbible logo - Sexual Wellness Insights & Sex Toy Reviews' : 'Lovefreund logo - Einblicke in sexuelle Wellness und Sexspielzeug-Bewertungen'}/>
			<div className={styles.bottomRow}></div>
		</>
    )
}